var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmenitySettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3751 1.91663H8.62508C5.45364 1.91663 4.79175 2.57852 4.79175 5.74996V21.0833H18.2084V5.74996C18.2084 2.57852 17.5465 1.91663 14.3751 1.91663Z",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 21.0834H20.125",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 21.0833V18.2083C14.375 16.6225 14.0441 16.2916 12.4583 16.2916H10.5417C8.95594 16.2916 8.625 16.6225 8.625 18.2083V21.0833",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 5.75H10.0625M12.9375 9.10417H10.0625M12.9375 12.4583H10.0625",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitySettings);
export default __webpack_public_path__ + "static/media/amenity-settings.2fce39a41ad8d1173636729cc0fdb59c.svg";
export { ForwardRef as ReactComponent };